"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileDialog = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const react_useauth_1 = __importDefault(require("@opsbase/react-useauth"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const react_1 = __importStar(require("react"));
const ProfileGeneralTab_1 = __importDefault(require("./ProfileGeneralTab"));
const ProfilePreferencesTab_1 = __importDefault(require("./ProfilePreferencesTab"));
function ProfileDialog() {
    const { api } = (0, react_useauth_1.default)();
    (0, react_1.useEffect)(() => {
        api.reloadSelf().catch(doNothing_1.default);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (react_1.default.createElement(Dialog_1.default, { size: DialogSize_1.default.X550_Y350, title: lib_i18n_1.default.t('my-profile-settings'), tabs: [
            {
                default: true,
                label: lib_i18n_1.default.t('general'),
                route: 'general',
                component: () => react_1.default.createElement(ProfileGeneralTab_1.default, null),
            },
            {
                label: lib_i18n_1.default.t('preferences'),
                route: 'preferences',
                component: () => react_1.default.createElement(ProfilePreferencesTab_1.default, null),
            },
        ] }));
}
exports.ProfileDialog = ProfileDialog;
exports.default = ProfileDialog;
